import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { queryDesignContent, QUERY_KEY, DesignContentQueryKey } from 'src/queries/queryDesignContent';

export const buildDesignContentQueryKey = (
    accessToken: string | undefined | false,
    productKey: string,
    productVersion: string,
    culture: string,
    designConceptId: string,
    selectedOptions?: Record<string, string>,
): DesignContentQueryKey => ([
    QUERY_KEY,
    accessToken,
    productKey,
    productVersion,
    culture,
    designConceptId,
    selectedOptions,
]);

export const useQueryDesignContent = (
    accessToken: string | undefined | false,
    productKey: string,
    productVersion: string,
    culture: string,
    designConceptId: string,
    selectedOptions?: Record<string, string>,
    options?: UseQueryOptions<any, Error, any, DesignContentQueryKey>,
): UseQueryResult<any, Error> => useQuery<any, Error, any, DesignContentQueryKey>(
    buildDesignContentQueryKey(accessToken, productKey, productVersion, culture, designConceptId, selectedOptions),
    queryDesignContent,
    {
        enabled: !!accessToken && !!productKey && !!productVersion && !!culture && !!designConceptId,
        suspense: false,
        ...options,
    },
);
